<template>
  <section>
    <h1 class="text-center mb-4 font-bold text-lg">Dashboard</h1>
    <article>
      <p class="bg-blue-100 p-5 border border-blue-200 rounded text-blue-500">
        This is the dashboard area which is secured via the router. A user must
        have an account and be logged in to view this page.
        {{currentUser}}
        {{tawwards}}
        <br/>
        <br/>
        {{awardsStuff}}
        <br/>
        <br/>
        <br/>
      
<span v-if="loaded">
         {{ info }}
         </span>
      </p>
      <button @click="testr"> test </button>
    </article>
  </section>
</template>

<script>

//import firebase from "firebase";
import { mapActions,mapGetters } from 'vuex'
// You would obiusly use this component to show secure dashboard information.
// As it stands it is just a simple Vue page with nothing intersting to show.
export default {
  
  data() {
    return {
      error: null,
      emailSending: false,
      awardsStuff:null,
      progressStuff:null,
      loaded:false,
    };
  },
    mounted() {
    const { currentUser } = this
    //console.log(currentUser)
    console.log(this)
    if (currentUser) {
      // Hide the loading screen if currentUser
      // is available before the page renders
      //this.$q.loading.hide()
      //this.getDataFromApi(this.currentUser.id)
      //console.log(currentUser)
      this.testr()
    }
  },
  computed: {
    ...mapGetters('user', ['currentUser']),

    tawwards() {
      return this.$store.state.awards_tracking;
    },
  info() {
      return this.$store.getters.getInfo
    }
  },

 methods: {
    ...mapActions('auth', ['loginUser']),
    ...mapActions('assessment', ['test2', 'loginUser']),
    ...mapActions('prog_tracking', ['getState', 'loginUser']),
    ...mapActions('awards_tracking', ['getAwardsState']),

   async testr()  {
    
   //   this.$refs.emailAuthenticationForm.validate().then(async (success) => {
     //   if (success) {
         // this.$q.loading.show({
        //    message: this.isRegistration
       //       ? 'Registering your account...'
        //      : 'Authenticating your account...',
       //     backgroundColor: 'grey',
       //     spinner: QSpinnerGears,
      //      customClass: 'loader'
     //     })
    // console.log(success)
          try {
            //console.log(this.currentUser)
               this.test2(this.currentUser.id)
               var progress = await this.getState(this.currentUser)
                              var awards=  await this.getAwardsState(this.currentUser)
                              this.progressStuff= progress 
                  this.awardsStuff = awards
                  this.loaded=true
                  console.log(this.$store.state)
          } catch (err) {
            this.error=err
          //  this.$q.notify({
         //     message: `An error as occured: ${err}`,
         //     color: 'negative'
         //   })
          } finally {
           // this.$router.push({ path: '/dashboard' })
          }
      //  }
     // })
    },
 }

}
</script>
